<template>
  <h-alert v-if="empty">{{ __('noOrders') }}</h-alert>
  <v-list
    v-else
    rounded
    color="transparent"
    class="pa-0"
  >
    <v-subheader>
      {{ __('openOrders') }}&nbsp;<small v-text="counter" />
    </v-subheader>
    <h-open-order
      v-for="order in orders"
      :key="`order${order.id}`"
      :order="order"
      @click="$emit('preview', order.id)"
      @more="showMore({
        free: false,
        id: order.id,
        event: $event,
      })"
    />
    <h-more
      v-model="more.show"
      v-bind="more"
    />
  </v-list>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import InteractsWithLoading from '@/Mixins/InteractsWithLoading'
  import MoreContextMenu from './MoreContextMenu'
  import HAlert from '@/Components/Messages/Alert'
  import HOpenOrder from './ListItem'

  export default {
    mixins: [
      I18n,
      InteractsWithLoading,
      MoreContextMenu,
    ],

    components: {
      HAlert,
      HOpenOrder,
    },

    computed: {
      orders () {
        return this.$store.state.orders.open
      },
      empty () {
        return ! this.loading && this.orders.length == 0
      },
      counter () {
        return this.empty ? '' : `(${this.orders.length})`
      },
    },
  }
</script>
